import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, GetDataGridItemsResponse, SetFiltersRequest } from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../grid/types/common';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { DEFAULT_PAGE_SIZE } from '../../../../grid/gridView/types';

export class IntegrityMonitorEventsGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private response: any;
  private limit = DEFAULT_PAGE_SIZE;

  constructor(public dependencies: any) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    request.pageSize = this.limit;

    const response = await this.dependencies.api.clients.IntegrityMonitorEvents.readRecords(request).toPromise();

    this.response = response;
    return sanitizeObject({
      summary: this.dependencies.translateFn('{noOfItems} items', {
        noOfItems: response.total,
      }),
      numItems: response.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    let response = this.response;
    request.pageSize = this.limit;

    if (!response) {
      response = await this.dependencies.api.clients.IntegrityMonitorEvents.readRecords(request).toPromise();
    } else {
      this.response = null;
    }

    return sanitizeObject({ rawEvents: response.data });
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.limit = request.pageSize ?? DEFAULT_PAGE_SIZE;
    return {};
  }

  async setFilters(_request: SetFiltersRequest): Promise<{} | undefined> {
    return;
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
